import React from "react";

export const McqQuestions = (props) => {
    return (
        <>
            <div className="col sb-mcq-card">
                <input id={props.id} name={props.name} type="radio" />
                <label htmlFor={props.for} className="radio-label">
                    <h4>{props.title}</h4>
                    <p>{props.description}</p>
                </label>              
            </div>
        </>
    )
}

export const McqQuestionsMultiple = (props) => {
    return (
        <>
            <div className="col sb-mcq-card">
                <input id={props.id} name={props.name} type="checkbox" />
                <label htmlFor={props.for} className="radio-label">
                    <h4>{props.title}</h4>
                    <p>{props.description}</p>
                </label>              
            </div>
        </>
    )
}